import React from 'react';
import {
    Modal, ModalHeader, ModalBody, Table, Badge, Row, Col
} from 'reactstrap';
import Moment from 'react-moment';
import 'moment-timezone';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHistory, faUser, faCalendarAlt, faPen, faArrowRight } from '@fortawesome/free-solid-svg-icons';

const getGrupoLabel = (grupo) => {
    switch (parseInt(grupo)) {
        case 1: return 'Bezerra';
        case 2: return 'Novilha';
        case 3: return 'Lactante';
        case 4: return 'Seca';
        case 5: return 'Corte';
        default: return grupo;
    }
};

const getStatusLabel = (status) => {
    switch (parseInt(status)) {
        case 1: return 'Vazia';
        case 2: return 'Inseminada';
        case 3: return 'Prenha';
        default: return status;
    }
};

export const ModalLog = ({ modal, toggle, log, id, brinco }) => {

    const renderValue = (val, campo) => {
        if (val === null || val === undefined || val === '') return <span className="text-muted font-italic small">vazio</span>;

        let displayValue = val;
        if (campo === 'grupo') displayValue = getGrupoLabel(val);
        if (campo === 'status') displayValue = getStatusLabel(val);

        return <span className="font-weight-bold text-dark">{displayValue}</span>;
    };

    return (
        <Modal isOpen={modal} toggle={toggle} size="lg" centered scrollable>
            <ModalHeader toggle={toggle} className="border-0 pb-0">
                <div className="d-flex align-items-center">
                    <div className="rounded-circle d-flex align-items-center justify-content-center mr-3" style={{ width: '45px', height: '45px', backgroundColor: 'var(--primary-color)', color: 'white' }}>
                        <FontAwesomeIcon icon={faHistory} size="lg" />
                    </div>
                    <div>
                        <h4 className="mb-0 font-weight-bold text-dark">Histórico de Alterações</h4>
                        <p className="text-muted small mb-0">
                            {brinco ? `Animal Brinco: ${brinco}` : (id ? `ID do Registro: ${id}` : 'Detalhes da auditoria')}
                        </p>
                    </div>
                </div>
            </ModalHeader>
            <ModalBody className="py-4">
                {log && log.length > 0 ? (
                    <div className="timeline-wrapper px-2" style={{ maxHeight: '600px', overflowY: 'auto' }}>
                        {log.map((n, index) => (
                            <div key={n.id || index} className="timeline-item position-relative mb-4 pb-2 border-left pl-4" style={{ borderColor: '#e9ecef', borderWidth: '2px' }}>
                                {/* Timeline Dot */}
                                <div
                                    className="position-absolute"
                                    style={{
                                        left: '-9px',
                                        top: '0',
                                        width: '16px',
                                        height: '16px',
                                        borderRadius: '50%',
                                        backgroundColor: 'var(--primary-color)',
                                        border: '3px solid white',
                                        boxShadow: '0 0 0 2px rgba(0,0,0,0.05)'
                                    }}
                                ></div>

                                <div className="d-flex justify-content-between align-items-center mb-2">
                                    <div className="d-flex align-items-center">
                                        <Badge color="light" className="text-primary border px-2 py-1 mr-2" style={{ borderColor: 'rgba(0,0,0,0.1) !important' }}>
                                            <FontAwesomeIcon icon={faPen} size="xs" className="mr-1" />
                                            {n.campo}
                                        </Badge>
                                    </div>
                                    <div className="text-muted small font-weight-bold">
                                        <FontAwesomeIcon icon={faCalendarAlt} className="mr-1" />
                                        <Moment format="DD/MM/YYYY HH:mm">{n.data_alteracao}</Moment>
                                    </div>
                                </div>

                                <div className="rounded p-3 mb-2 border-0" style={{ backgroundColor: '#f8f9fa' }}>
                                    <Row className="align-items-center">
                                        <Col xs={5}>
                                            <div className="small text-muted mb-1 text-uppercase font-weight-bold" style={{ fontSize: '10px', letterSpacing: '0.5px' }}>De</div>
                                            <div className="text-break">{renderValue(n.ValorAntigo, n.campo)}</div>
                                        </Col>
                                        <Col xs={2} className="text-center p-0">
                                            <FontAwesomeIcon icon={faArrowRight} className="text-muted opacity-50" />
                                        </Col>
                                        <Col xs={5}>
                                            <div className="small text-muted mb-1 text-uppercase font-weight-bold" style={{ fontSize: '10px', letterSpacing: '0.5px' }}>Para</div>
                                            <div className="text-break">{renderValue(n.ValorNovo, n.campo)}</div>
                                        </Col>
                                    </Row>
                                </div>

                                <div className="d-flex align-items-center text-muted small">
                                    <FontAwesomeIcon icon={faUser} className="mr-1" size="xs" />
                                    <span>Alterado por: <span className="font-weight-bold text-dark">{n.NomeUsuario}</span></span>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="text-center py-5">
                        <div className="bg-light rounded-circle d-inline-flex align-items-center justify-content-center p-4 mb-3">
                            <FontAwesomeIcon icon={faHistory} size="3x" className="text-muted opacity-50" />
                        </div>
                        <h5 className="text-secondary">Nenhum histórico encontrado</h5>
                        <p className="text-muted">As alterações realizadas aparecerão listadas aqui em ordem cronológica.</p>
                    </div>
                )}
            </ModalBody>
            <style>{`
                .timeline-item:last-child {
                    border-left: 2px solid transparent !important;
                    margin-bottom: 0 !important;
                }
                .timeline-wrapper::-webkit-scrollbar {
                    width: 6px;
                }
                .timeline-wrapper::-webkit-scrollbar-track {
                    background: #f1f1f1;
                    border-radius: 10px;
                }
                .timeline-wrapper::-webkit-scrollbar-thumb {
                    background: #ccc;
                    border-radius: 10px;
                }
                .timeline-wrapper::-webkit-scrollbar-thumb:hover {
                    background: var(--primary-color);
                }
            `}</style>
        </Modal>
    );

};